import { stripeEnvironment } from "@/lib/stripe";

const PaymentTestModeBanner = () => {
  if (stripeEnvironment !== "sandbox") return null;

  return (
    <div className="w-full bg-amber-100 border-b border-amber-300 px-4 py-2 text-center text-[10px] uppercase tracking-widest text-amber-900">
      Testläge — använd kortet 4242 4242 4242 4242 för att testa betalning
    </div>
  );
};

export default PaymentTestModeBanner;
